/* eslint-disable @typescript-eslint/triple-slash-reference */
/// <reference path="../node_modules/@ketch-sdk/ketch-types/dist/index.d.ts" />;
import React, { useEffect } from "react";

export function useKetchProps(): {
    href: string;
    onClick: () => void;
    children: React.ReactNode;
} {
    const [ketchRegion, setKetchRegion] = React.useState("");

    useEffect(() => {
        const cb = (region: string) => {
            setKetchRegion(region);
        };
        window.ketch("on", "regionInfo", cb);
        return window.ketch("off", "regionInfo", cb);
    });

    return {
        href: "#",
        onClick: () => window.ketch("showExperience"),
        children:
            ketchRegion === "US-CA"
                ? "Do Not Sell My Personal Information"
                : "Your privacy choices",
    };
}
